import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import {
  PropertyManagerPortalService
} from './shared/integrations/property-manager-portal/property-manager-portal.service';
import { PspService } from './shared/integrations/psp/psp.service';
import { PayLaterService } from './shared/integrations/pay-later/pay-later.service';
import { WelcomeModule } from './welcome/welcome.module';
import { SecurityDepositModule } from './security-deposit/security-deposit.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule.forRoot(),
    CoreModule,
    WelcomeModule,
    SecurityDepositModule,
  ],
  providers: [
    PropertyManagerPortalService,
    PspService,
    PayLaterService,
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always', subscriptSizing: 'dynamic' } }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
